import HelpCenter from '../components/HelpCenter';

const HelpPage = () => {
  return <HelpCenter />;
};

export default HelpPage;
